export const scoreView = {
    "submit_successful": "You have submitted successfully!",
    "congratulations": "congratulations!",
    "sorry": "sorry",
    "completed": "completed",
};
